import { createIcon } from "@chakra-ui/icons";

const AuditLogIcon = createIcon({
  displayName: "AuditLog",
  viewBox: "0 0 14 14",
  path: (
    <>
      <path d="M6.99928 7.38979C8.71772 7.38979 10.1108 5.99672 10.1108 4.27827C10.1108 2.55982 8.71772 1.16675 6.99928 1.16675C5.28083 1.16675 3.88776 2.55982 3.88776 4.27827C3.88776 5.99672 5.28083 7.38979 6.99928 7.38979Z"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.03644 4.27817H6.99927V2.72241"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.6665 3.40954C11.96 3.38983 12.2603 3.37738 12.5642 3.37272C12.6353 3.37149 12.7039 3.39854 12.755 3.44791C12.78 3.47225 12.7998 3.50137 12.8133 3.53354C12.8267 3.5657 12.8336 3.60025 12.8333 3.63512V10.6096C12.833 10.6785 12.8056 10.7446 12.7572 10.7936C12.7087 10.8427 12.643 10.8708 12.5741 10.872C9.5787 10.9161 6.99925 11.7194 6.99925 12.7052C6.99925 11.7199 4.41979 10.9161 1.42599 10.8699C1.35707 10.8687 1.29135 10.8406 1.2429 10.7915C1.19444 10.7425 1.16709 10.6765 1.1667 10.6075V3.63305C1.16637 3.59835 1.17294 3.56393 1.18603 3.53179C1.19911 3.49965 1.21846 3.47043 1.24293 3.44584C1.29409 3.39652 1.36272 3.36948 1.43377 3.37064C1.73282 3.37479 2.03187 3.38689 2.33093 3.40694"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.99927 9.0752V12.64"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />

    </>
  ),
});

export default AuditLogIcon;
